<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <!-- MAC码 -->
              <a-col :xxl="8" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                <a-form-item label="MAC码" prop="mac">
                  <a-input
                    v-model:value="queryParam.mac"
                    placeholder="请输入MAC码"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <!-- 岗位名称 -->
              <a-col :xxl="8" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                <a-form-item label="岗位名称" prop="name">
                  <a-input
                    v-model:value="queryParam.name"
                    placeholder="请输入岗位名称"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <!-- 是否通知 -->
              <!--            <a-col :md="6" :sm="24">-->
              <!--              <a-form-item label="是否通知" prop="isNotice">-->
              <!--                <a-select-->
              <!--                  v-model:value="queryParam.isNotice"-->
              <!--                  placeholder="请选择是否通知"-->
              <!--                  allow-clear-->
              <!--                  style="width: 100%"-->
              <!--                  class="no-border-radius-select"-->
              <!--                >-->
              <!--                  <a-select-option-->
              <!--                    v-for="dict in dict.type['is_notice']"-->
              <!--                    :key="dict.value"-->
              <!--                    :value="dict.value"-->
              <!--                  >-->
              <!--                    {{ dict.label }}-->
              <!--                  </a-select-option>-->
              <!--                </a-select>-->
              <!--              </a-form-item>-->
              <!--            </a-col>-->

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24" class="search-actions-col">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                    <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                      {{ advanced ? '收起' : '展开' }}
                      <UpOutlined v-if="advanced" />
                      <DownOutlined v-else />
                    </a-button>
                  </span>
                </a-form-item>
              </a-col>

              <!-- 高级搜索条件（展开后显示） -->
              <template v-if="advanced">
                <!-- 手环类型 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                  <a-form-item label="手环类型" prop="type">
                    <a-select
                      v-model:value="queryParam.type"
                      placeholder="请选择手环类型"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="dict in dict.type['wristband_type']"
                        :key="dict.value"
                        :value="dict.value"
                      >
                        {{ dict.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- 手环岗位描述 -->
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="手环岗位描述" prop="description" :colon="false">-->
                <!--                  <a-input-->
                <!--                    v-model:value="queryParam.description"-->
                <!--                    placeholder="请输入手环岗位描述"-->
                <!--                    allow-clear-->
                <!--                    class="no-border-radius-input"-->
                <!--                  />-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->
                <!-- 手环状态 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                  <a-form-item label="手环状态" prop="wristbandStatus">
                    <a-select
                      v-model:value="queryParam.wristbandStatus"
                      placeholder="请选择手环状态"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="dict in dict.type['wristband_status']"
                        :key="dict.value"
                        :value="dict.value"
                      >
                        {{ dict.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- 状态 -->
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="状态" prop="status">-->
                <!--                  <a-input v-model="queryParam.status" placeholder="请输入状态" allow-clear/>-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->
                <!-- 佩戴人 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                  <a-form-item label="佩戴人" prop="nickname">
                    <a-input
                      v-model:value="queryParam.nickname"
                      placeholder="请输入佩戴人"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!-- 定位安装设备 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                  <a-form-item label="定位安装设备" prop="equipmentName" :colon="false">
                    <a-input
                      v-model:value="queryParam.equipmentName"
                      placeholder="请输入定位安装设备"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!-- 绑定时间 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                  <a-form-item label="绑定时间" prop="bindTimeStart">
                    <a-range-picker
                      style="width: 100%"
                      v-model:value="bindTimeRange"
                      format="YYYY-MM-DD"
                      valueFormat="YYYY-MM-DD"
                      :placeholder="['开始日期', '结束日期']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <!-- 手环佩戴类型 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                  <a-form-item label="手环佩戴类型" prop="wearType" :colon="false">
                    <a-select
                      v-model:value="queryParam.wearType"
                      placeholder="请选择手环佩戴类型"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="dict in dict.type['type_of_wristband']"
                        :key="dict.value"
                        :value="dict.value"
                      >
                        {{ dict.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- 工作流名称 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                  <a-form-item label="工作流名称" prop="workflowName">
                    <a-input
                      v-model:value="queryParam.workflowName"
                      placeholder="请输入工作流名称"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!-- 工作流描述 -->
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="工作流描述" prop="workflowDescription">-->
                <!--                  <a-input-->
                <!--                    v-model:value="queryParam.workflowDescription"-->
                <!--                    placeholder="请输入工作流描述"-->
                <!--                    allow-clear-->
                <!--                    class="no-border-radius-input"-->
                <!--                  />-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->
                <!-- 工作流类型 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
                  <a-form-item label="工作流类型" prop="workflowType">
                    <a-select
                      v-model:value="queryParam.workflowType"
                      placeholder="请选择工作流类型"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option v-for="dict in dict.type['workflow_type']" :key="dict.value" :value="dict.value">
                        {{ dict.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- 工作流是否启动 -->
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="工作流启动" prop="workflowStatus" :colon="false">-->
                <!--                  <a-select-->
                <!--                    v-model:value="queryParam.workflowStatus"-->
                <!--                    placeholder="请选择工作流是否启动"-->
                <!--                    allow-clear-->
                <!--                    style="width: 100%"-->
                <!--                    class="no-border-radius-select"-->
                <!--                  >-->
                <!--                    <a-select-option-->
                <!--                      v-for="dict in dict.type['workflow_status']"-->
                <!--                      :key="dict.value"-->
                <!--                      :value="dict.value"-->
                <!--                    >-->
                <!--                      {{ dict.label }}-->
                <!--                    </a-select-option>-->
                <!--                  </a-select>-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="24" :sm="24" :xs="24" class="search-actions-col">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作 -->
        <div class="table-operations" ref="operationsRef">
          <a-button
            type="text"
            shape="circle"
            @click="resetQuery"
            v-hasPermi="['system:wristband:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button type="primary" @click="handleAdd" v-hasPermi="['system:wristband:add']" class="add-button">
            <PlusOutlined />新增
          </a-button>
          <a-button
            @click="handleExportWristband"
            v-hasPermi="['system:wristband:export']"
            class="no-border-button import-export-button"
          >
            <UploadOutlined />导出手环
          </a-button>
          <a-button
            @click="handleImportExcel"
            v-hasPermi="['system:wristband:import']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导入手环
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleExportWorkflow"
            v-hasPermi="['system:wristband:exportWorkflow']"
            class="no-border-button import-export-button"
          >
            <UploadOutlined />导出工作流
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleImportWorkflow"
            v-hasPermi="['system:wristband:importWorkflow']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导入工作流
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleEnable"
            v-hasPermi="['system:wristband:enable']"
            class="no-border-button batch-operation-button"
          >
            <CheckCircleOutlined />启用
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDisable"
            v-hasPermi="['system:wristband:disable']"
            class="no-border-button batch-operation-button"
          >
            <CloseCircleOutlined />暂停
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:wristband:remove']"
            class="no-border-button batch-operation-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <a-button
            @click="handleDownloadTemplate"
            v-hasPermi="['system:wristband:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />手环导入模版下载
          </a-button>
          <a-button
            @click="handleDownloadWorkflowTemplate"
            v-hasPermi="['system:wristband:importWorkflowTemplate']"
            class="no-border-button workflow-template-download-button"
          >
            <CloudDownloadOutlined />工作流导入模版下载
          </a-button>
          <!-- <table-setting
          :style="{ float: 'right' }"
          v-model:table-size="tableSize"
          v-model:value="columns"
          :refresh-loading="loading"
          @refresh="getList"
        /> -->
        </div>
        <!-- 增加修改 -->
        <import-excel ref="importExcel" @ok="getList" />
        <create-form ref="createForm" @ok="getList" @close="getList" />
        <import-workflow ref="importWorkflow" @ok="getList" />
        <!-- 工作流明细弹窗 -->
        <workflow-detail
          :visible="workflowDetailVisible"
          :wristband-id="currentWristbandId"
          :wristband-name="currentWristbandName"
          :wristband-workflow-type="currentWristbandWorkflowType"
          @close="handleWorkflowDetailClose"
          @workflow-conversion="handleWorkflowConversion"
        />
        <wristband-log
          :visible="wristbandLogVisible"
          :wristband-id="currentWristbandLogId"
          :wristband-name="currentWristbandLogName"
          @close="handleWristbandLogClose"
        />
        <wristband-maintenance
          :visible="wristbandMaintenanceVisible"
          :wristband-id="currentMaintenanceId"
          :wristband-name="currentMaintenanceName"
          @close="handleWristbandMaintenanceClose"
        />
        <!-- 数据展示 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 'max-content' }"
            class="optimized-table"
          >
            <!-- 手环类型、手环状态、工作流类型、工作流是否启动和是否通知字典显示 -->
            <template #bodyCell="{ column, text, record }">
              <template v-if="column.dataIndex === 'type'">
                <dict-tag :options="dict.type['wristband_type']" :value="record.type" />
              </template>
              <template v-else-if="column.dataIndex === 'wristbandStatus'">
                <span>{{ text == 0 ? '待定' : text == 1 ? '启用' : text == 2 ? '暂停' : text }}</span>
              </template>
              <template v-else-if="column.dataIndex === 'workflowType'">
                <span>{{ text == 0 ? 'AI工作流' : text == 1 ? '顺序工作流' : text == 2 ? '灵活工作流' : text }}</span>
              </template>
              <template v-else-if="column.dataIndex === 'workflowStatus'">
                <span>{{ text == 0 ? '禁用' : text == 1 ? '启动' : text }}</span>
              </template>
              <template v-else-if="column.dataIndex === 'isNotice'">
                <span>{{
                  text == 0
                    ? '不通知'
                    : text == 1
                    ? '通知'
                    : text == null || text == undefined || text === ''
                    ? '通知(未设置)'
                    : text
                }}</span>
              </template>
              <template v-else-if="column.dataIndex === 'wearType'">
                <dict-tag :options="dict.type['type_of_wristband']" :value="record.wearType" />
              </template>
            </template>
            <!-- 绑定时间：格式化显示 -->
            <template v-slot:bindTime="text, record">
              <span>
                {{ parseTime(record.bindTime) }}
              </span>
            </template>

            <!-- 操作列：编辑、删除 -->
            <template #operation="{ record }">
              <div class="table-action-buttons">
                <a
                  @click="handleWorkflowDetail(record)"
                  v-hasPermi="['system:wristband:workflowDetails']"
                  class="workflow-detail-link"
                >
                  工作流明细
                </a>
                <span class="action-divider" v-hasPermi="['system:wristband:workflowDetails']">|</span>

                <a
                  @click="handleWristbandMaintenance(record)"
                  v-hasPermi="['system:wristband:maintenance']"
                  class="maintenance-link"
                >
                  维护管理
                </a>
                <span class="action-divider" v-hasPermi="['system:wristband:maintenance']">|</span>

                <a
                  @click="handleWristbandLog(record)"
                  v-hasPermi="['system:wristband:braceletLog']"
                  class="wristband-log-link"
                >
                  手环日志
                </a>
                <span class="action-divider" v-hasPermi="['system:wristband:braceletLog']">|</span>

                <a
                  @click="$refs.createForm.handleUpdate(record, undefined)"
                  v-hasPermi="['system:wristband:edit']"
                  class="edit-link"
                >
                  编辑
                </a>
              </div>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              class="ant-table-pagination"
              show-size-changer
              show-quick-jumper
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
/**
 * 手环管理页面
 * 功能：提供手环的查询、新增、编辑、删除、导入导出、启用/禁用等操作
 * - 根据选中的项目ID过滤手环列表
 * - 支持按MAC码、岗位名称、手环类型、手环状态等条件搜索
 * - 支持高级搜索展开/收起
 * - 支持批量删除、启用、禁用
 */
import { pageWristband, delWristband, changeWristbandStatus } from '@/api/system/wristband'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons-vue'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import ImportWorkflow from './modules/ImportWorkflow'
import WorkflowDetail from './modules/WorkflowDetail'
import WristbandLog from './modules/WristbandLog'
import WristbandMaintenance from './modules/WristbandMaintenance'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Wristband',
  components: {
    CreateForm,
    ImportExcel,
    ImportWorkflow,
    WorkflowDetail,
    WristbandLog,
    WristbandMaintenance,
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    LeftOutlined,
    RightOutlined,
    PlusOutlined,
    DownloadOutlined,
    UploadOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    DeleteOutlined,
    CloudDownloadOutlined,
  },
  dicts: ['wristband_type', 'wristband_status', 'workflow_type', 'workflow_status', 'type_of_wristband', 'is_notice'],
  mixins: [tableMixin],
  data() {
    return {
      // 手环列表数据
      list: [],
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 选中的ID数组（用于批量删除、启用/禁用等操作）
      ids: [],
      // 高级搜索展开/关闭状态
      advanced: false,
      // 非单个禁用（用于控制批量操作的按钮状态）
      single: true,
      // 非多个禁用（用于控制批量操作的按钮状态）
      multiple: true,
      // 加载状态
      loading: false,
      // 总记录数
      total: 0,
      // 工作流明细弹窗相关
      workflowDetailVisible: false, // 工作流明细弹窗显示/隐藏状态
      currentWristbandId: null, // 当前查看工作流明细的手环ID
      currentWristbandName: '', // 当前查看工作流明细的岗位名称
      currentWristbandWorkflowType: null, // 当前查看工作流明细的手环工作流类型
      wristbandLogVisible: false, // 手环日志弹窗显示/隐藏状态
      currentWristbandLogId: null, // 当前查看日志的手环ID
      currentWristbandLogName: '', // 当前查看日志的岗位名称
      wristbandMaintenanceVisible: false, // 手环维护弹窗显示/隐藏状态
      currentMaintenanceId: null, // 当前维护的手环ID
      currentMaintenanceName: '', // 当前维护的岗位名称
      jumpPage: 1, // 分页跳转页码
      // 查询参数（只包含表格显示的字段和分页参数，顺序与表格列顺序一致）
      queryParam: {
        projectId: null, // 项目ID（从Vuex自动获取）
        mac: null, // MAC码
        name: null, // 岗位名称
        isNotice: undefined, // 是否通知
        type: undefined, // 手环类型
        description: null, // 手环岗位描述
        wristbandStatus: undefined, // 手环状态
        status: null, // 状态
        nickname: null, // 佩戴人
        equipmentName: null, // 定位安装设备
        bindTimeStart: undefined, // 绑定开始时间
        bindTimeEnd: undefined, // 绑定结束时间
        wearType: undefined, // 手环佩戴类型
        workflowName: null, // 工作流名称
        workflowDescription: null, // 工作流描述
        workflowType: undefined, // 工作流类型
        workflowStatus: undefined, // 工作流是否启动
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页显示数量
      },
      // 表格列配置（顺序与筛选项顺序一致）- 基础配置，序号列在 computed 中处理
      baseColumns: [
        {
          title: 'MAC码',
          dataIndex: 'mac',
          align: 'center',
        },
        {
          title: '岗位名称',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '手环类型',
          dataIndex: 'type',
          align: 'center',
          scopedSlots: { customRender: 'type' },
        },
        // {
        //   title: '手环岗位描述',
        //   dataIndex: 'description',
        //   ellipsis: true,
        //   align: 'center',
        //   width: 220
        // },
        {
          title: '手环状态',
          dataIndex: 'wristbandStatus',
          ellipsis: true,
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'wristbandStatus' },
        },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   align: 'center',
        // },
        {
          title: '佩戴人',
          dataIndex: 'nickname',
          align: 'center',
        },
        {
          title: '定位安装设备',
          dataIndex: 'equipmentName',
          align: 'center',
        },
        {
          title: '绑定时间',
          dataIndex: 'bindTime',
          scopedSlots: { customRender: 'bindTime' },
          align: 'center',
        },
        {
          title: '手环佩戴类型',
          dataIndex: 'wearType',
          align: 'center',
          scopedSlots: { customRender: 'wearType' },
        },
        {
          title: '工作流名称',
          dataIndex: 'workflowName',
          align: 'center',
        },
        {
          title: '工作流描述',
          dataIndex: 'workflowDescription',
          align: 'center',
        },
        {
          title: '工作流类型',
          dataIndex: 'workflowType',
          align: 'center',
          scopedSlots: { customRender: 'workflowType' },
        },
        {
          title: '工作流是否启动',
          dataIndex: 'workflowStatus',
          align: 'center',
          scopedSlots: { customRender: 'workflowStatus' },
        },
        {
          title: '是否通知',
          dataIndex: 'isNotice',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'isNotice' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 400,
          slots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  computed: {
    bindTimeRange: {
      get() {
        const begin = this.queryParam.bindTimeStart
        const end = this.queryParam.bindTimeEnd
        return begin && end ? [begin, end] : []
      },
      set(val) {
        const begin = Array.isArray(val) && val.length > 0 ? val[0] : undefined
        const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
        this.queryParam.bindTimeStart = begin || undefined
        this.queryParam.bindTimeEnd = end || undefined
      },
    },
    // 表格列配置（使用 computed 以便在 customRender 中访问 this）
    columns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'index',
          width: 80,
          align: 'center',
          customRender: ({ index }) => {
            const pageNum = that.queryParam.pageNum || 1
            const pageSize = that.queryParam.pageSize || 10
            const currentIndex = index !== undefined && index !== null ? Number(index) : 0
            if (isNaN(currentIndex) || isNaN(pageNum) || isNaN(pageSize)) {
              return currentIndex + 1
            }
            return (pageNum - 1) * pageSize + currentIndex + 1
          },
        },
        ...this.baseColumns, // 保留其他列配置
      ]
    },
    submitButtonStyle() {
      return {}
    },
  },
  created() {
    // 初始化时从 Vuex 获取项目ID
    const currentProjectId = this.$store.getters.currentProjectId
    if (currentProjectId) {
      this.queryParam.projectId = currentProjectId
    }
    // 页面创建时加载数据列表
    this.getList()
    // 监听项目变化事件（使用 $root 事件总线）
    $on(this.$root, 'project-changed', this.handleProjectChanged)
  },
  beforeUnmount() {
    // 移除事件监听
    $off(this.$root, 'project-changed', this.handleProjectChanged)
  },
  methods: {
    /**
     * 更新操作区域滚动条，使其与表格横向滚动联动
     * 解决操作按钮过多时，顶部操作栏没有横向滚动条的问题
     */
    updateOperationScroll() {
      this.$nextTick(() => {
        const operations = this.$refs.operationsRef
        if (!operations) {
          return
        }

        // 找到当前页面中的表格内容区域
        const tableBody = this.$el.querySelector('.optimized-table .ant-table-body')
        if (!tableBody) {
          return
        }

        // 设置操作栏容器的宽度与表格可视区域一致
        operations.style.maxWidth = tableBody.clientWidth + 'px'

        // 只绑定一次联动事件
        if (!this._operationScrollBound) {
          this._operationScrollBound = true

          // 表格滚动时，同步顶部操作栏的滚动位置
          tableBody.addEventListener('scroll', () => {
            operations.scrollLeft = tableBody.scrollLeft
          })
        }
      })
    },

    /**
     * 字典加载完成回调
     * @param {Object} dict - 字典对象
     */
    onDictReady(dict) {
      // 字典加载完成后的回调，用于消除 Vue 警告
      // 字典数据已经通过 this.dict 可用，无需额外处理
    },

    /**
     * 获取手环类型文字（根据 wristband_type 字典）
     * @param {String|Number} value - 手环类型值
     * @returns {String} 手环类型文字
     */
    getWristbandTypeLabel(value) {
      return this.getDictLabel('wristband_type', value)
    },

    /**
     * 获取字典文字
     * @param {String} dictType - 字典类型
     * @param {String|Number} value - 字典值
     * @returns {String} 字典文字
     */
    getDictLabel(dictType, value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      // 确保 dict 对象存在
      if (!this.dict || !this.dict.type) {
        console.warn(`字典对象不存在: dictType=${dictType}, value=${value}`)
        return String(value)
      }
      const dictList = this.dict.type[dictType]
      if (!dictList || !Array.isArray(dictList) || dictList.length === 0) {
        console.warn(`字典列表为空: dictType=${dictType}, value=${value}`)
        return String(value)
      }

      // 将值转换为数字和字符串两种形式进行匹配
      const valueNum = typeof value === 'number' ? value : Number(value)
      const valueStr = String(value)
      const isValueNumeric = !isNaN(valueNum) && valueNum !== null

      // 查找匹配的字典项
      const dictItem = dictList.find((item) => {
        if (!item || item.value === undefined || item.value === null) {
          return false
        }
        const itemValue = item.value
        const itemValueNum = typeof itemValue === 'number' ? itemValue : Number(itemValue)
        const itemValueStr = String(itemValue)
        const isItemNumeric = !isNaN(itemValueNum) && itemValueNum !== null

        // 1. 严格相等匹配
        if (itemValue === value) {
          return true
        }
        // 2. 字符串匹配
        if (itemValueStr === valueStr) {
          return true
        }
        // 3. 数字匹配（如果都是有效数字）
        if (isValueNumeric && isItemNumeric && itemValueNum === valueNum) {
          return true
        }
        return false
      })

      if (dictItem && dictItem.label) {
        return dictItem.label
      }

      console.warn(`未找到匹配的字典项: dictType=${dictType}, value=${value}, dictList=`, dictList)
      return String(value)
    },

    /**
     * 查询手环列表
     * 根据查询参数分页获取手环数据
     */
    getList() {
      // 每次查询前同步 Vuex 中的当前项目ID
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.queryParam.projectId = currentProjectId
      }
      this.loading = true
      pageWristband(this.queryParam)
        .then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.jumpPage = this.queryParam.pageNum
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
        .finally(() => {
          this.$nextTick(() => {
            this.updateOperationScroll()
          })
        })
    },

    /**
     * 处理项目变化事件
     * 当右侧项目选择发生变化时，更新查询参数并刷新列表
     * @param {Number} projectId - 新选中的项目ID（可能为 undefined，表示清空选择）
     */
    handleProjectChanged(projectId) {
      // 更新查询参数中的项目ID
      this.queryParam.projectId = projectId || undefined
      // 重置到第一页并刷新列表
      this.queryParam.pageNum = 1
      this.getList()
    },

    /**
     * 检查是否已选择项目
     * @returns {Boolean} 是否已选择项目
     */
    checkProjectSelected() {
      const currentProjectId = this.$store.getters.currentProjectId
      if (!currentProjectId) {
        this.$message.warning('请先选择项目', 3)
        return false
      }
      return true
    },

    /**
     * 新增按钮操作
     * 检查项目选择后打开新增表单
     */
    handleAdd() {
      if (!this.checkProjectSelected()) {
        return
      }
      this.$refs.createForm.handleAdd()
    },

    /**
     * 导入手环按钮操作
     * 检查项目选择后打开导入弹窗
     */
    handleImportExcel() {
      if (!this.checkProjectSelected()) {
        return
      }
      this.$refs.importExcel.importExcelHandleOpen()
    },

    /**
     * 导入工作流按钮操作
     * 需要至少选择一个手环，将选中的手环ID传递给导入组件
     */
    handleImportWorkflow() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择需要导入工作流的手环', 3)
        return
      }
      this.$refs.importWorkflow.importExcelHandleOpen(this.selectedRowKeys)
    },

    /**
     * 搜索按钮操作
     * 重置到第一页并重新查询
     */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    /**
     * 重置按钮操作
     * 清空所有查询条件，保留项目ID（从Vuex获取）和分页参数
     */
    resetQuery() {
      // 从 Vuex 获取当前项目ID作为默认值
      const currentProjectId = this.$store.getters.currentProjectId
      this.queryParam = {
        projectId: currentProjectId || undefined, // 项目ID（从Vuex获取）
        mac: undefined, // MAC码
        name: undefined, // 岗位名称
        isNotice: undefined, // 是否通知
        type: undefined, // 手环类型
        description: undefined, // 手环岗位描述
        wristbandStatus: undefined, // 手环状态
        status: undefined, // 状态
        nickname: undefined, // 佩戴人
        equipmentName: undefined, // 定位安装设备
        bindTimeStart: undefined, // 绑定开始时间
        bindTimeEnd: undefined, // 绑定结束时间
        wearType: undefined, // 手环佩戴类型
        workflowName: undefined, // 工作流名称
        workflowDescription: undefined, // 工作流描述
        workflowType: undefined, // 工作流类型
        workflowStatus: undefined, // 工作流是否启动
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页显示数量
      }
      this.handleQuery()
    },

    /**
     * 每页条数变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },

    /**
     * 分页变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },

    /**
     * 跳转到指定页码
     */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },

    /**
     * 表格行选择变化
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      // 更新按钮禁用状态
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },

    /**
     * 切换高级搜索展开/收起
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    /**
     * 删除按钮操作
     * @param {Object} row - 要删除的手环记录（可选，如果传入则删除单条，否则删除选中的多条）
     */
    handleDelete(row) {
      const that = this
      // 如果传入了row，则删除单条；否则删除选中的多条
      const wristbandIds = row ? [row.id] : this.ids

      if (!wristbandIds || wristbandIds.length === 0) {
        this.$message.warning('请先选择要删除的数据', 3)
        return
      }

      // 如果传入了row，添加到ids数组中
      if (row && row.id) {
        if (!this.ids.includes(row.id)) {
          this.ids.push(row.id)
        }
      }

      // 获取要删除的岗位名称
      let wristbandNames = []
      if (row && row.name) {
        // 单行删除，显示该行的岗位名称
        wristbandNames = [row.name]
      } else if (this.selectedRows && this.selectedRows.length > 0) {
        // 多行删除，显示所有选中行的岗位名称
        wristbandNames = this.selectedRows.map((item) => item.name).filter((name) => name)
      }

      const nameText = wristbandNames.length > 0 ? wristbandNames.join('、') : ''

      this.$confirm({
        title: '确认删除所选中数据?',
        content: nameText ? `删除岗位名称为：${nameText} 的数据` : '确认删除所选数据?',
        onOk() {
          // 批量删除
          const data = that.ids.map((id) => ({ id }))
          return delWristband(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
            .catch(() => {
              that.$message.error('删除失败', 3)
            })
        },
        onCancel() {
          // 取消时清空删除ids列表
          that.ids = []
        },
      })
    },

    /**
     * 下载导入模板
     */
    handleDownloadTemplate() {
      this.download('system/wristband/importTemplate', {}, `手环导入模板_${new Date().getTime()}.xls`)
    },

    /**
     * 下载工作流导入模板
     */
    handleDownloadWorkflowTemplate() {
      this.download('system/wristband-workflow/importTemplate', {}, `手环工作流模板_${new Date().getTime()}.xls`)
    },

    /**
     * 导出按钮操作
     * 支持导出选中数据或当前筛选条件下的全部数据
     */
    handleExportWristband() {
      const that = this
      const hasSelection = that.selectedRowKeys && that.selectedRowKeys.length > 0
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
        onOk() {
          const params = { ...that.queryParam }
          // 如果选中了数据，则传递wristbandIds参数
          if (hasSelection) {
            params.wristbandIds = that.selectedRowKeys
          }
          that.download('system/wristband/export', params, `手环_${new Date().getTime()}.xls`)
        },
        onCancel() {},
      })
    },

    /**
     * 导出选中手环的工作流
     */
    handleExportWorkflow() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择需要导出工作流的手环', 3)
        return
      }
      const that = this
      this.$confirm({
        title: '是否确认导出选中手环的工作流?',
        content: `将导出 ${this.selectedRowKeys.length} 个手环的工作流信息`,
        onOk() {
          const params = { wristbandIds: that.selectedRowKeys }
          that.download('system/wristband-workflow/exportByWristband', params, `手环工作流_${new Date().getTime()}.xls`)
        },
        onCancel() {},
      })
    },

    /**
     * 启用按钮操作
     * 批量启用选中的手环
     */
    handleEnable() {
      this.handleChangeStatus(1)
    },

    /**
     * 禁用按钮操作
     * 批量禁用选中的手环
     */
    handleDisable() {
      this.handleChangeStatus(0)
    },

    /**
     * 批量修改状态（启用/禁用）
     * @param {Number} status - 状态值，1-启用，0-禁用
     */
    handleChangeStatus(status) {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择需要操作的数据', 3)
        return
      }
      const actionText = status === 1 ? '启用' : '禁用'
      const ids = [...this.selectedRowKeys].join(',')
      this.$confirm({
        title: `确认${actionText}所选中数据?`,
        content: `当前选中编号为 ${ids} 的数据`,
        onOk: () => {
          const data = {
            ids,
            status: status,
          }
          return changeWristbandStatus(data)
            .then(() => {
              this.$message.success(`${actionText}成功`, 3)
              this.onSelectChange([], [])
              this.getList()
            })
            .catch(() => {
              this.$message.error(`${actionText}失败`, 3)
            })
        },
      })
    },

    /**
     * 查看工作流明细
     * 打开工作流明细弹窗，传入手环ID和名称查询工作流明细
     * @param {Object} record - 手环记录对象
     */
    handleWorkflowDetail(record) {
      if (!record || !record.id) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      this.currentWristbandId = record.id
      this.currentWristbandName = record.name || record.mac || ''
      this.currentWristbandWorkflowType = record.workflowType
      this.workflowDetailVisible = true
    },

    /**
     * 关闭工作流明细弹窗
     * 重置相关状态
     */
    handleWorkflowDetailClose() {
      this.workflowDetailVisible = false
      this.currentWristbandId = null
      this.currentWristbandName = ''
      this.currentWristbandWorkflowType = null
    },

    /**
     * 工作流转换成功回调
     * 刷新手环列表数据
     * @param {Object} payload - 工作流转换信息
     */
    handleWorkflowConversion(payload = {}) {
      // 刷新手环列表
      this.getList()
    },

    /**
     * 打开手环日志弹窗
     * @param {Object} record 手环记录
     */
    handleWristbandLog(record) {
      if (!record || !record.id) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      this.currentWristbandLogId = record.id
      this.currentWristbandLogName = record.name || record.mac || ''
      this.wristbandLogVisible = true
    },

    /**
     * 关闭手环日志弹窗
     */
    handleWristbandLogClose() {
      this.wristbandLogVisible = false
      this.currentWristbandLogId = null
      this.currentWristbandLogName = ''
    },

    /**
     * 打开手环维护弹窗
     */
    handleWristbandMaintenance(record) {
      if (!record || !record.id) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      this.currentMaintenanceId = record.id
      this.currentMaintenanceName = record.name || record.mac || ''
      this.wristbandMaintenanceVisible = true
    },

    /**
     * 关闭手环维护弹窗
     */
    handleWristbandMaintenanceClose() {
      this.wristbandMaintenanceVisible = false
      this.currentMaintenanceId = null
      this.currentMaintenanceName = ''
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 让搜索栏的 FormItem 在一行内左右排布：左侧文字固定宽度，右侧输入区域自适应 */
.table-page-search-wrapper :deep(.ant-form-item) {
  display: flex;
  align-items: center;
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-label) {
  flex: 0 0 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 auto;
  margin-left: 8px;
  min-width: 0;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content) {
  width: 100%;
  min-width: 0;
}

.search-actions-col {
  display: flex;
  justify-content: flex-end;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  max-width: 260px;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  max-width: 260px;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
  /* flex-wrap: wrap; */
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

@media (max-width: 992px) {
  .table-page-search-wrapper :deep(.ant-form-item) {
    flex-direction: column;
    align-items: stretch;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label) {
    width: auto;
    min-width: 0;
    flex: 0 0 auto;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label > label) {
    width: auto;
    text-align: left;
  }

  .table-page-search-wrapper :deep(.ant-form-item-control) {
    margin-left: 0;
  }

  .search-actions-col {
    justify-content: flex-start;
  }
}

.table-operations {
  display: flex;
  align-items: center;
  /* gap: 8px; */
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
  white-space: nowrap;
}

/* 顶部操作栏横向滚动条样式 */
.table-operations::-webkit-scrollbar {
  height: 8px;
}

.table-operations::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

.table-operations::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 4px;
}

.table-operations::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 选中行的操作列样式 */
.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 全选按钮indeterminate状态：改为蓝色 */
.optimized-table :deep(.ant-checkbox-indeterminate .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-indeterminate .ant-checkbox-inner::after) {
  background-color: #ffffff !important;
  border-top-color: #ffffff !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  border-left-color: transparent !important;
}

.optimized-table :deep(.ant-checkbox-indeterminate:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 操作列按钮样式 */
.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 工作流明细按钮颜色 */
.table-action-buttons .workflow-detail-link {
  color: #ff6d3b !important;
}

.table-action-buttons .workflow-detail-link:hover {
  color: #ff8c5a !important;
}

/* 维护管理按钮颜色 */
.table-action-buttons .maintenance-link {
  color: #1eb3df !important;
}

.table-action-buttons .maintenance-link:hover {
  color: #4bc5e8 !important;
}

/* 手环日志按钮颜色 */
.table-action-buttons .wristband-log-link {
  color: #333333 !important;
}

.table-action-buttons .wristband-log-link:hover {
  color: #333333 !important;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background: #f3f3f3 !important;
  color: #101010 !important;
}

/* 导入导出按钮背景颜色 */
.import-export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button :deep(.anticon) {
  color: #333 !important;
}

.import-export-button:hover:not(:disabled),
.import-export-button:focus:not(:disabled) {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button:hover:not(:disabled) :deep(.anticon),
.import-export-button:focus:not(:disabled) :deep(.anticon) {
  color: #333 !important;
}

/* 导入导出按钮禁用状态 - 参照 projectUser 页面修改状态按钮 */
.import-export-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

.import-export-button:disabled :deep(.anticon) {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 批量操作按钮样式（启用、暂停、删除）- 参照 projectUser 页面修改状态按钮 */
.batch-operation-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.batch-operation-button:hover,
.batch-operation-button:focus {
  color: #333333 !important;
}

.batch-operation-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 手环导入模版下载按钮文字和图标颜色 */
.template-download-button {
  color: #f89c2a !important;
  background: transparent !important;
  border: none !important;
}

.template-download-button :deep(.anticon) {
  color: #f89c2a !important;
}

.template-download-button:hover,
.template-download-button:focus {
  color: #f89c2a !important;
  background: transparent !important;
  border: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #f89c2a !important;
}

/* 工作流导入模版下载按钮文字和图标颜色 */
.workflow-template-download-button {
  color: #165dff !important;
  background: transparent !important;
  border: none !important;
}

.workflow-template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.workflow-template-download-button:hover,
.workflow-template-download-button:focus {
  color: #165dff !important;
  background: transparent !important;
  border: none !important;
}

.workflow-template-download-button:hover :deep(.anticon),
.workflow-template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}
</style>

<style>
/* 确认弹窗按钮样式 */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

/* Modal 弹窗按钮样式 - 适用于所有通过 import 引入的组件 */
.ant-modal-footer .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-footer .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-footer .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-footer .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-footer .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-footer .ant-btn-default {
  border-radius: 4px !important;
}
</style>
